import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { getResourceName } from '@/shared/components/ResourceName';
const QUERY_KEY = 'RegistrationResources';
const useGetRegistrationResources = (type = 0) => {
    const intl = useIntl();
    return useQuery([QUERY_KEY, type], () => api.base
        .get('/api/resource/Registration', { params: { type } })
        .then(res => res.data.map(x => {
        var _a;
        return (Object.assign(Object.assign({}, x), { code: x.code || '', displayName: (_a = getResourceName(intl, x)) !== null && _a !== void 0 ? _a : x.name }));
    })), {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetRegistrationResources;
